export const viewTitle = "Журнал информационной безопасности";
export const viewUniqKey = "IS-journal";
